module.exports = __webpack_public_path__ + "img/parallax-purple.3ecabd07.jpg";